import jwtDecode from "jwt-decode";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import ErrorHandler from "../../../../common/ErrorHandler";
import Table from "../../../../common/Table/Table";
import useCreateTAUserModal from "../hooks/useCreateTAUserModal";

const CreateTAUserModal = (props) => {
  const { onHide, userModal, setUserModal } = props;
  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);

  const {
    buttonLoader,
    taUserData,
    TAUserList,
    handleSelectedUserConformation,
    handleSelect,
  } = useCreateTAUserModal(onHide);



  try {
    return (
      <Modal
        {...props}
        size="md"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <div>
            <h5>Select TA User</h5>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 mt-1">
            <Select
              options={TAUserList}
              name="phone"
              placeholder="Select....."
              onChange={handleSelect}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999, 
                }),
              }}
            />
          </div>
          {Object.entries(taUserData).length > 0 && (
            <>
              {taUserData?.is_user_channel_financed && (
                <div className="d-flex justify-content-center align-items-center text-danger">
                  This User Already TA User
                </div>
              )}
              <div className="mt-2">
                <Table
                  data={[taUserData]}
                  columns={[
                    {
                      title: "Name",
                      data_key: "userName",
                    },
                    {
                      title: "Phone",
                      data_key: "phone",
                    },
                    {
                      title: "State",
                      data_key: "state_name",
                    },
                    {
                      title: "TA Financier",
                      data_key: "is_ta_financier_applicable",
                      render: (row) => (
                        <div className="text-center">
                          {row?.is_ta_financier_applicable ? (
                            <span className="badge bg-success">
                              <i className="bi bi-check-circle-fill me-1"></i>
                              Allowed
                            </span>
                          ) : (
                            <span className="badge bg-danger">
                              <i className="bi bi-x-circle-fill me-1"></i>
                              Not Allowed
                            </span>
                          )}
                        </div>
                      ),
                    },
                  ]}
                  loading={false}
                  loading_rows={3}
                  loading_cols={2}
                  no_data_msg="No User Found"
                />
              </div>
              
              {!taUserData?.is_user_channel_financed && !taUserData?.is_ta_financier_applicable && (
                <div className="alert alert-warning mt-3 mb-0" role="alert">
                  <div className="d-flex align-items-start">
                    <i className="bi bi-info-circle-fill me-2 mt-1"></i>
                    <div>
                      <strong>Important Notice:</strong>
                      <p className="mb-2 mt-1">
                        Trade Advance financing through external financiers is not permitted in this state.
                      </p>
                      <p className="mb-1">
                        <strong>Next Steps:</strong>
                      </p>
                      <ul className="mb-0 ps-3">
                        <li>Financing will be provided directly by Meratractor</li>
                        <li>This case requires admin approval before proceeding</li>
                        <li>Onboarding process will begin after approval</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            {buttonLoader ? (
              <button
                className="btn btn-success"
                type="button"
                disabled
                id="loadingBtnTp"
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            ) : (
              <Button
                variant="success"
                onClick={handleSelectedUserConformation}
              >
                Confirm
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    );
  } catch (error) {
    return <ErrorHandler error={error} />;
  }
};

export default CreateTAUserModal;
